import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoMdDownload, IoIosClose } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import Loader from '../../../components/Loader';
import { _HttpServices } from "../../../_services/_HttpServices";
import moment from 'moment'
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const PurchasesPage = () => {
    const fileName = 'Purchases';
    const [startDate, setStartDate] = useState(new Date().setHours(0, 0, 0, 0))
    const [endDate, setEndDate] = useState(new Date().setHours(0, 0, 0, 0))
    const [purchases, setPurchases] = useState([]);
    const [load, setLoading] = useState(false)
    const [purchasesList, setPurchasesList] = useState([])
    const [modalShow, setModalShow] = useState(false)
    let filterStartDate = moment(startDate).format("L")
    let filterEndDate = moment(endDate).format("L")
    const [purchaseList, setPurchaseList] = useState([])
    const [validated, setValidated] = useState(false)
    const [btnDisable, setBtnDisable] = useState(true)
    const [greaterErr, setGreaterErr] = useState(false)
    const [emptyErr, setEmptyErr] = useState(false)
    const [hasError, setHasError] = useState(false);
    const submitHandler = (e) => {
        e.preventDefault()
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
        } else {
            e.preventDefault()
            if (startDate > endDate) {
                setGreaterErr(true)
                return false
            } else if (startDate < endDate) {
                setGreaterErr(false)
            } else {
                setGreaterErr(false)
            }

            if (startDate === 0) {
                setEmptyErr(true)
                return false
            }

            filterStartDate = moment(startDate).format("L")
            filterEndDate = moment(endDate).format("L")


            getPurchases()
            setBtnDisable(true)
        }
        setValidated(true)
    }

    useEffect(() => {
        getPurchases();
    }, [])
    async function getPurchases() {
        setLoading(true)
        await _HttpServices
            .getData(`api/inbound/purchases?_startDate=${filterStartDate}&_endDate=${filterEndDate}&Id=-1`)
            .then((data) => {
                const response = data.data

                if (response.length > 0) {
                    response.map((res) => {
                        res.PurchasesDate = moment(res.PurchasesDate).format('MM/DD/YYYY');
                        res.CreatedDate = moment(res.CreatedDate).format('MM/DD/YYYY');
                        res.ReceivedDate = moment(res.ReceivedDate).format('MM/DD/YYYY')
                        res.Purchasesscost = "$" + (res.Purchasesscost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.PurchasesNetcost = "$" + (res.PurchasesNetcost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.PurchasesTotal = "$" + (res.PurchasesTotal * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

                    })
                }
                const uniqData = Array.from(new Set(response.map(a => a.PurchasesId)))
                    .map(id => {
                        return response.find(a => a.PurchasesId === id)
                    })

                const purchasesResult = uniqData
                setPurchaseList(response);
                setPurchases(purchasesResult)
                setLoading(false)
                setValidated(false)
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setValidated(false);
                setHasError(true);
            });
    }

    const getChildRecords = async (id) => {
        setLoading(true)
        setModalShow(true)
        await _HttpServices
            .getData(`api/inbound/purchases?_startDate=${filterStartDate}&_endDate=${filterEndDate}&Id=${id}`)
            .then((data) => {
                const result = data.data
                if (result.length > 0) {
                    result.map((res) => {
                        res.CreatedDate = moment(res.CreatedDate).format('MM/DD/YYYY');
                        res.Total = "$" + (res.Total * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.Purchasesscost = "$" + (res.Purchasesscost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.PurchasesNetcost = "$" + (res.PurchasesNetcost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                    })

                }
                setPurchasesList(result)
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
                console.log(e)
                setValidated(false);
                setHasError(true);
            });
    }
    const handleClose = () => {
        setPurchasesList([])
        return setModalShow(false)
    }
    const columns = [{
        Header: 'Purchases ID',
        accessor: 'PurchasesId',
        filter: 'PurchasesId',
        sortType: 'basic',
    },
    {
        Header: 'SKU',
        accessor: 'SKU',
        filter: 'SKU',
        sortType: 'basic',
    },
    {
        Header: 'NDC',
        accessor: 'NDC',
        filter: 'NDC',
        sortType: 'basic',
    },
    {
        Header: 'Part Number',
        accessor: 'PartNumber',
        filter: 'PartNumber',
        sortType: 'basic',
    },
    {
        Header: 'Product ',
        accessor: 'Product',
        filter: 'Product',
        sortType: 'basic',
    },
    {
        Header: 'Purchase Quantity ',
        accessor: 'PurchasesQuantity',
        filter: 'PurchasesQuantity',
        sortType: 'basic',
    },
    {
        Header: 'Purchase Cost ',
        accessor: 'Purchasesscost',
        filter: 'Purchasesscost',
        sortType: 'basic',
    },
    {
        Header: 'Purchase Net Cost ',
        accessor: 'PurchasesNetcost',
        filter: 'PurchasesNetcost',
        sortType: 'basic',
    },
    {
        Header: 'Purchase Total',
        accessor: 'Total',
        filter: 'Total',
        sortType: 'basic',
    },
    {
        Header: 'Created Date ',
        accessor: 'CreatedDate',
        filter: 'CreatedDate',
        sortType: 'basic',
        filterMethod: (filter, row) => {
            const rowValue = row.original
            return rowValue.datefiled.includes(filter.value)
        },
    }
    ];

    const mainGridColumns = [
        {
            Header: 'Purchases ID',
            accessor: 'PurchasesId',
            filter: 'PurchasesId',
            sortType: 'basic',
            Cell: ({ row: { original } }) => (
                <Button variant="link" onClick={() => getChildRecords(original.PurchasesId)} className="grid-action-btn">{original.PurchasesId}</Button>
            )
        }, {
            Header: 'Vendor Name ',
            accessor: 'VendorName',
            filter: 'VendorName',
            sortType: 'basic'
        }, {
            Header: 'Vendor Address Line1',
            accessor: 'VendorAddressLine1',
            filter: 'VendorAddressLine1',
            sortType: 'basic'
        }, {
            Header: 'Vendor City',
            accessor: 'VendorCity',
            filter: 'VendorCity',
            sortType: 'basic',
        }, {
            Header: 'Vendor State',
            accessor: 'VendorState',
            filter: 'VendorState',
            sortType: 'basic',
        },
        {
            Header: 'Vendor Zip Code ',
            accessor: 'VendorZipCode',
            filter: 'VendorZipCode',
            sortType: 'basic',
        },
        {
            Header: 'Vendor Country ',
            accessor: 'VendorCountry',
            filter: 'VendorCountry',
            sortType: 'basic',
        },
        {
            Header: 'Bill to Name ',
            accessor: 'BillToName',
            filter: 'BillToName',
            sortType: 'basic',
        },
        {
            Header: 'Bill to Address Line1',
            accessor: 'BillToAddressLine1',
            filter: 'BillToAddressLine1',
            sortType: 'basic',
        },
        {
            Header: 'Bill to Address Line2',
            accessor: 'BillToAddressLine2',
            filter: 'BillToAddressLine2',
            sortType: 'basic',
        },
        {
            Header: 'Bill to City',
            accessor: 'BillToCity',
            filter: 'BillToCity',
            sortType: 'basic',
        },
        {
            Header: 'Bill to State',
            accessor: 'BillToState',
            filter: 'BillToState',
            sortType: 'basic',
        },
        {
            Header: 'Bill To Zip Code ',
            accessor: 'BillToZipCode',
            filter: 'BillToZipCode',
            sortType: 'basic',
        },
        {
            Header: 'Bill To Country ',
            accessor: 'BillToCountry',
            filter: 'BillToCountry',
            sortType: 'basic',
        },
        {
            Header: 'Ship To Name',
            accessor: 'ShipToName',
            filter: 'ShipToName',
            sortType: 'basic',
        },
        {
            Header: 'Ship To Address Line1',
            accessor: 'ShipToAddressLine1',
            filter: 'ShipToAddressLine1',
            sortType: 'basic',
        },
        {
            Header: 'Ship To Address Line2',
            accessor: 'ShipToAddressLine2',
            filter: 'ShipToAddressLine2',
            sortType: 'basic',
        },
        {
            Header: 'Ship To City  ',
            accessor: 'ShipToCity',
            filter: 'ShipToCity',
            sortType: 'basic',
        },
        {
            Header: 'Ship To state ',
            accessor: 'ShipToState',
            filter: 'ShipToState',
            sortType: 'basic',
        },
        {
            Header: 'Ship To Zip Code',
            accessor: 'ShipToZipCode',
            filter: 'ShipToZipCode',
            sortType: 'basic',
        },
        {
            Header: 'Ship To Country ',
            accessor: 'ShipToCountry',
            filter: 'ShipToCountry',
            sortType: 'basic',
        },
        {
            Header: 'Purchase Total',
            accessor: 'PurchasesTotal',
            filter: 'PurchasesTotal',
            sortType: 'basic',
        },
        {
            Header: 'Purchases Date ',
            accessor: 'PurchasesDate',
            filter: 'PurchasesDate',
            sortType: 'basic',
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: 'Purchases Status',
            accessor: 'PurchasesStatus',
            filter: 'PurchasesStatus',
            sortType: 'basic',
        }, {
            Header: 'Email Id',
            accessor: 'Email',
            filter: 'Email',
            sortType: 'basic',
        },
        {
            Header: 'Created Date ',
            accessor: 'CreatedDate',
            filter: 'CreatedDate',
            sortType: 'basic',
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            },
        }
    ]
    const newColumn = columns.slice(0);
    newColumn.splice(0, 1);
    const excelHeder = mainGridColumns.concat(newColumn);
    return (
        <section className="content">

            {/* Modal */}
            <Modal show={modalShow} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Purchase Order List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {hasError ? <p>Error occurred. Unable to load purchases.</p> :
                        <Fragment>
                            {purchasesList.length > 0 ? (
                                <ReactTable columns={columns} data={purchasesList} defaultPageSize={10} />
                            ) : (
                                    <div className="no-data">No data found.</div>
                                )}
                        </Fragment>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}><IoIosClose className="icon btn-icon" />Close</Button>
                </Modal.Footer>
            </Modal>

            <div className="page-title">
                <h2 className="h2">Purchase Order</h2>
                {load ? <Loader /> : null}
                {purchases.length > 0 ? <Button type="submit" onClick={() => getExcel(excelHeder, purchaseList, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button> : null}
            </div>

            <Row>
                <Col md={12}>
                    <div className="card pt-2 mb-4">
                        <div className="card-body">
                            <Form noValidate validated={validated} onSubmit={submitHandler}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="StartDate">
                                                    Since
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setBtnDisable(false)
                                                        return setStartDate(date)
                                                    }}
                                                    onSelect={(date) => {
                                                        setGreaterErr(false)
                                                        setBtnDisable(false)
                                                    }}
                                                    maxDate={new Date()}
                                                    required className={greaterErr ? "form-control is-invalid" : "form-control"}
                                                />
                                                {emptyErr ? <div className="err-feedback">Please select Start Date.</div> : null}
                                                {greaterErr ? <div className="err-feedback">Since should not be greater than until date.</div> : null}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="EndDate">
                                                    Until
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setBtnDisable(false)
                                                        return setEndDate(date)
                                                    }}
                                                    onSelect={(date) => {
                                                        setBtnDisable(false)
                                                    }}
                                                    maxDate={new Date()}
                                                    required className="form-control"
                                                />
                                                <Form.Control.Feedback type="invalid">Please select End Date.</Form.Control.Feedback>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mt-2">
                                            <Button type="submit" className="mt-3" disabled={btnDisable}>
                                                <IoMdDoneAll className="icon btn-icon" />Submit</Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>

                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                                <div className="inventory-grid">
                                    {hasError ? <p>Error occurred. Unable to load purchases.</p> :
                                        <Fragment>
                                            {purchases.length > 0 ?
                                                <ReactTable columns={mainGridColumns} data={purchases} defaultPageSize={10} />
                                                :
                                                <div className="no-data">No data found.</div>
                                            }
                                        </Fragment>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <Footer />

        </section>

    )

}

export default PurchasesPage